import find from 'lodash/find';

export default function isCustomLayer(
    layerTypeCategories: LayerTypeCategory[] | undefined,
    layerId: string
) {
    if (!layerTypeCategories) return false;

    const customLayers = find(layerTypeCategories, (l) => l.id === 'custom');

    return Boolean(customLayers && customLayers.sources.includes(layerId));
}
